export const IDENTITY_SDK_VERSION = "2.21.0"
